/* bnf-forms v3 · Oct 31 2026 · Bodno native forms (replaced Globo Form Builder).
   v3 (Oct 31, Eli: "capture as much as you can"): the visitor-source block at the end of this file records where each
   visitor came from and saves it with their email whenever any bodno.com form, quote, quiz or chat collects one
   (Supabase table form_sources; read by the Thursday forms digest). It never changes what a form sends.
   ALERT_TO is empty: Eli gets the Thursday digest instead of an email per form; reps are emailed server side.
   v2.1 (Oct 26): data-alert-to="a@x.com,b@y.com" on a form adds alert recipients for that form only
   (each must carry the Omnisend tag website-form-alerts). Used by the support-article "still stuck" form → jack@feryllc.com.
   v2: file uploads (input[type=file] name="file", up to 3, 10 MB each), data-ctx (copies a heading's text into the
   hidden "request" field), and the support forms (data-hs-do-not-collect) only show success once site-forms saved them,
   because that save is what opens the HubSpot ticket.
   Every form[data-bnf] on the page:
     1. checks the required fields,
     2. saves the submission to the site-forms backend (BodnoHQ → Forms: stored, sorted, assigned),
     3. fires two Omnisend events from the browser, the same way the trade-in page does:
        "website form confirmation" → the customer (automation picks the email by form_key)
        "website form alert"        → each address in ALERT_TO (must carry the Omnisend tag website-form-alerts).
   Fields marked data-private (leasing: EIN, date of birth, ownership %) go to site-forms only, never to email.
   Submissions from an unpublished (preview) theme are saved as tests in BodnoHQ. */
(function () {
  if (window.BNF) return;
  window.BNF = { v: 3 };
  var API = 'https://ekpavfdzsrfathpwjrwu.supabase.co/functions/v1/site-forms';
  var ALERT_TO = []; // Oct 31 (Eli): no per-form alert to Eli (weekly digest instead). Per-form data-alert-to still works (still-stuck → Jack); the assigned rep is emailed server side
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var isTest = function () { return !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'); };

  function fields(form) {
    var out = {}, labels = {}, priv = {};
    var els = form.querySelectorAll('input[name], select[name], textarea[name]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], n = el.name;
      if (n === 'bnf_hp' || el.type === 'file') continue;
      if (el.type === 'radio') { if (el.checked) out[n] = el.value; }
      else if (el.type === 'checkbox') out[n] = el.checked ? 'yes' : (out[n] || 'no');
      else out[n] = String(el.value || '').trim();
      if (el.getAttribute('data-label')) labels[n] = el.getAttribute('data-label');
      if (el.hasAttribute('data-private')) priv[n] = 1;
    }
    return { values: out, labels: labels, priv: priv };
  }

  function check(form) {
    var bad = null, seen = {};
    var req = form.querySelectorAll('[required]');
    for (var i = 0; i < req.length; i++) {
      var el = req[i], ok;
      if (el.type === 'radio') {
        if (seen[el.name]) continue; seen[el.name] = 1;
        ok = !!form.querySelector('input[name="' + el.name + '"]:checked');
      } else if (el.type === 'checkbox') ok = el.checked;
      else if (el.type === 'file') ok = !!(el.files && el.files.length);
      else {
        ok = !!String(el.value || '').trim();
        if (ok && el.type === 'email') ok = EMAIL_RE.test(el.value.trim());
      }
      var w = el.closest('.bnf-f, .bnf-choice'); if (w) w.classList.toggle('bnf-bad', !ok);
      if (!ok && !bad) bad = el;
    }
    return bad;
  }

  function omni(done) {
    var tries = 0;
    (function wait() {
      if (window.omnisend && typeof window.omnisend.push === 'function') done(true);
      else if (++tries < 25) setTimeout(wait, 120);
      else done(false);
    })();
  }

  function sendOmnisend(form, f, cb) {
    var v = f.values, key = form.getAttribute('data-bnf'), name = form.getAttribute('data-bnf-name') || key;
    var std = { name: 1, first_name: 1, last_name: 1, email: 1, phone: 1, company: 1, message: 1, reason: 1, industry: 1 };
    var details = [];
    for (var k in v) {
      if (!v.hasOwnProperty(k) || std[k] || f.priv[k] || v[k] === '' || v[k] == null) continue;
      details.push((f.labels[k] || k.replace(/_/g, ' ')) + ': ' + v[k]);
    }
    var who = v.name || [v.first_name, v.last_name].filter(Boolean).join(' ') || v.email;
    omni(function (ready) {
      if (!ready) { cb(false); return; }
      try {
        if (typeof window.omnisend.identifyContact === 'function') window.omnisend.identifyContact({ email: v.email });
        window.omnisend.push(['track', 'website form confirmation', { origin: 'api', contact: { email: v.email }, properties: { form_key: key, form_name: name } }]);
        var to = ALERT_TO.concat(String(form.getAttribute('data-alert-to') || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(function (x) { return EMAIL_RE.test(x) && ALERT_TO.indexOf(x) < 0; }));
        for (var a = 0; a < to.length; a++) {
          window.omnisend.push(['track', 'website form alert', { origin: 'api', contact: { email: to[a] }, properties: {
            form_key: key, form_name: (isTest() ? 'TEST · ' : '') + name, customer_name: who || '—', customer_email: v.email || '—', customer_phone: v.phone || '—',
            company: v.company || '—', topic: v.reason || v.industry || '—', message: v.message || '—', details: details.join(' · ') || '—',
            page_url: location.origin + location.pathname
          } }]);
        }
        cb(true);
      } catch (e) { cb(false); }
    });
  }

  var FILE_OK = /^(image\/(png|jpe?g|gif|webp|heic|heif)|application\/pdf)$/;
  function files(form) {
    var out = [], ins = form.querySelectorAll('input[type="file"]');
    for (var i = 0; i < ins.length; i++) for (var j = 0; j < (ins[i].files || []).length; j++) out.push(ins[i].files[j]);
    return out;
  }
  // null = fine, else the message to show
  function checkFiles(list) {
    if (list.length > 3) return 'Please attach up to 3 files.';
    for (var i = 0; i < list.length; i++) {
      if (list[i].size > 10 * 1024 * 1024) return list[i].name + ' is larger than 10 MB.';
      if (!FILE_OK.test(list[i].type)) return list[i].name + ': please attach a photo (JPG, PNG, HEIC) or a PDF.';
    }
    return null;
  }

  // resolves { ok, error }
  function saveSiteForms(form, f, t0, list) {
    var fd = new FormData();
    fd.append('payload', JSON.stringify({ form: form.getAttribute('data-bnf'), page: location.pathname + location.search, hp: '', t: Date.now() - t0, test: isTest(), fields: f.values }));
    for (var i = 0; i < list.length; i++) fd.append('file', list[i], list[i].name);
    // keepalive caps the body at 64 KB, so uploads go without it
    return fetch(API, { method: 'POST', body: fd, keepalive: !list.length }).then(function (r) { return r.json(); })
      .then(function (j) { return { ok: !!(j && j.ok), error: j && j.error ? String(j.error) : null }; })
      .catch(function () { return { ok: false, error: null }; });
  }

  function done(form) {
    var box = document.createElement('div');
    box.className = 'bnf-done';
    box.setAttribute('role', 'status');
    var t = form.getAttribute('data-ok-title') || 'Thank you!', m = form.getAttribute('data-ok-msg') || 'We will get back to you soon.';
    var g = form.getAttribute('data-guide-url');
    box.innerHTML = '<div class="bnf-ok" aria-hidden="true">✓</div><p class="bnf-done-t"></p><p class="bnf-done-m"></p>' +
      (g ? '<a class="btn btn--red btn--bold-700 bnf-dl" target="_blank" rel="noopener">Download the guide now</a>' : '');
    box.querySelector('.bnf-done-t').textContent = t;
    box.querySelector('.bnf-done-m').textContent = m;
    if (g) box.querySelector('.bnf-dl').href = g;
    form.parentNode.replaceChild(box, form);
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'bnf_submit', form_name: form.getAttribute('data-bnf') });
      if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { form_name: form.getAttribute('data-bnf') });
    } catch (e) {}
  }

  function bind(form) {
    if (form.__bnf) return; form.__bnf = true;
    var t0 = Date.now();
    var msg = form.querySelector('.bnf-msg');
    form.addEventListener('input', function (e) { var w = e.target.closest && e.target.closest('.bnf-bad'); if (w) w.classList.remove('bnf-bad'); });
    form.addEventListener('change', function (e) { var w = e.target.closest && e.target.closest('.bnf-bad'); if (w) w.classList.remove('bnf-bad'); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.__sending) return;
      var bad = check(form);
      if (bad) { if (msg) { msg.hidden = false; msg.textContent = 'Please fill in the highlighted fields.'; } try { bad.focus(); } catch (x) {} return; }
      if (msg) msg.hidden = true;
      var list = files(form), fileErr = checkFiles(list);
      if (fileErr) { if (msg) { msg.hidden = false; msg.textContent = fileErr; } return; }
      var hp = form.querySelector('[name="bnf_hp"]');
      if ((hp && hp.value) || Date.now() - t0 < 2500) { done(form); return; }
      var ctx = form.getAttribute('data-ctx'), req = form.querySelector('[name="request"]');
      if (ctx && req) { var ce = document.querySelector(ctx); req.value = ce ? String(ce.textContent || '').trim().slice(0, 120) : ''; }
      form.__sending = true;
      var btn = form.querySelector('[type="submit"]'), label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = list.length ? 'Uploading…' : 'Sending…'; }
      // support forms: the site-forms save opens the HubSpot ticket, so only that counts as sent
      var mustSave = form.hasAttribute('data-hs-do-not-collect') || list.length > 0;
      var f = fields(form), left = 2, saved = { ok: false, error: null }, mailedOk = false;
      var finish = function () {
        if (--left > 0) return;
        if (saved.ok || (mailedOk && !mustSave)) { done(form); return; }
        form.__sending = false;
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        if (msg) { msg.hidden = false; msg.textContent = saved.error || 'Something went wrong sending your request. Please try again, or call (732) 987-5300.'; }
      };
      saveSiteForms(form, f, t0, list).then(function (r) { saved = r; finish(); });
      sendOmnisend(form, f, function (ok) { mailedOk = ok; finish(); });
    });
  }

  function init() { var fs = document.querySelectorAll('form[data-bnf]'); for (var i = 0; i < fs.length; i++) bind(fs[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* bnf-forms v3 · visitor source (Oct 31 2026). Runs on every bodno.com page (this file loads site-wide).
   Keeps, in the visitor's own browser:
     first touch   (localStorage bodno_src_f, 1 year): the very first landing page, outside referrer, utm_*, ad click ids
     this session  (sessionStorage bodno_src_s): the same for this visit, plus the pages viewed (last 20)
     visits        (localStorage bodno_src_v): how many visits
   When an email is entered and sent anywhere on the site (any form submit, or a post to site-forms, quiz-lead / quotes,
   the printer finder or the site chat), one row goes to Supabase form_sources: email, which form or post, page, first
   touch, session touch, pages, visits, device. Insert-only (the browser cannot read the table). Nothing a form sends changes.
   Ad click ids are kept only when marketing is allowed (same rule as bodno-ads-conv). Any error is swallowed.
   To undo: delete this block (everything below the line above it). */
(function () {
  try {
    if (window.__bodnoSrc || /voltyid/i.test(location.hostname)) return;
    window.__bodnoSrc = 1;
    var URL_ = 'https://ekpavfdzsrfathpwjrwu.supabase.co/rest/v1/form_sources';
    var KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVrcGF2ZmR6c3JmYXRocHdqcnd1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA2NTg0MTgsImV4cCI6MjA4NjIzNDQxOH0.QgtOWA6kr6YVSHJ2fXFRmG8zcl_mgxgI8nN8dYCX-G8'; // public anon key (insert-only on form_sources)
    var EMAIL = /^[^\s@<>()]+@[^\s@<>()]+\.[a-z]{2,}$/i;
    var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
    var CLICK = ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid', 'msclkid', 'fbclid', 'li_fat_id'];
    var cut = function (v, n) { return String(v == null ? '' : v).slice(0, n); };
    var get = function (st, k) { try { return JSON.parse(st.getItem(k) || 'null'); } catch (e) { return null; } };
    var put = function (st, k, v) { try { st.setItem(k, JSON.stringify(v)); } catch (e) {} };
    var marketingOk = function () { try { var cp = window.Shopify && Shopify.customerPrivacy; if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() !== false; } catch (e) {} return true; };
    var host = function (h) { return String(h || '').toLowerCase().replace(/^www\./, ''); };

    // what this page load tells us about where the visitor came from
    var q = new URLSearchParams(location.search), touch = { t: new Date().toISOString(), land: cut(location.pathname, 250) }, signal = false;
    try {
      if (document.referrer) {
        var r = new URL(document.referrer);
        if (host(r.hostname) !== host(location.hostname) && !/(^|\.)(myshopify\.com|shopify\.com|shop\.app|bodno\.com)$/.test(host(r.hostname))) {
          touch.ref = cut(host(r.hostname) + r.pathname, 200); signal = true;
          var rq = new URLSearchParams(r.search), kw = rq.get('q') || rq.get('p') || rq.get('query'); // some engines still pass it
          if (kw) touch.ref_q = cut(kw, 150);
        }
      }
    } catch (e) {}
    UTM.forEach(function (k) { var v = q.get(k); if (v) { touch[k] = cut(v, 150); signal = true; } });
    if (marketingOk()) CLICK.forEach(function (k) { var v = q.get(k); if (v) { touch[k] = cut(v, 300); signal = true; } });

    var first = get(localStorage, 'bodno_src_f');
    if (!first || Date.now() - Date.parse(first.t) > 365 * 864e5) { first = touch; put(localStorage, 'bodno_src_f', first); }
    var sess = get(sessionStorage, 'bodno_src_s');
    if (!sess || (signal && sess.touch && sess.touch.land !== touch.land)) {
      var visits = (Number(get(localStorage, 'bodno_src_v')) || 0) + (sess ? 0 : 1);
      put(localStorage, 'bodno_src_v', visits);
      sess = { touch: touch, pages: sess ? sess.pages : [], n: sess ? sess.n : 0 };
    }
    var path = cut(location.pathname, 120);
    if (sess.pages[sess.pages.length - 1] !== path) sess.pages.push(path);
    sess.pages = sess.pages.slice(-20); sess.n = (sess.n || 0) + 1;
    put(sessionStorage, 'bodno_src_s', sess);

    // one row per email + page, per visit (kind = whatever sent it first)
    var origFetch = window.fetch ? window.fetch.bind(window) : null;
    function save(email, kind) {
      try {
        email = String(email || '').trim().toLowerCase();
        if (!EMAIL.test(email) || !origFetch) return;
        var s = get(sessionStorage, 'bodno_src_s') || sess, key = email + '|' + location.pathname; // a bnf form is seen twice (its submit + its site-forms post): one row
        var sent = get(sessionStorage, 'bodno_src_sent') || [];
        if (sent.indexOf(key) > -1) return;
        sent.push(key); put(sessionStorage, 'bodno_src_sent', sent.slice(-30));
        var testTheme = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
        var pq = new URLSearchParams(location.search); CLICK.forEach(function (k) { pq.delete(k); }); var qs = pq.toString(); // click ids live in the touches, not the page
        origFetch(URL_, { method: 'POST', keepalive: true, headers: { apikey: KEY, Authorization: 'Bearer ' + KEY, 'Content-Type': 'application/json', Prefer: 'return=minimal' },
          body: JSON.stringify({ email: email, kind: cut((testTheme ? 'test:' : '') + kind, 40), page: cut(location.pathname + (qs ? '?' + qs : ''), 400),
            first_touch: get(localStorage, 'bodno_src_f') || first, session_touch: s.touch, pages: s.pages, visits: Number(get(localStorage, 'bodno_src_v')) || 1,
            device: window.innerWidth < 768 ? 'mobile' : window.innerWidth < 1100 ? 'tablet' : 'desktop' }) }).catch(function () {});
      } catch (e) {}
    }

    // 1. any form on the page that is submitted with an email in it
    document.addEventListener('submit', function (ev) {
      try {
        var f = ev.target; if (!f || !f.querySelector) return;
        var em = f.querySelector('input[type=email], input[name=email], input[name=email_address], input[name$="[email]"], input[name="contact[email]"]');
        if (em && em.value) save(em.value, 'form:' + (f.getAttribute('data-bnf') || f.id || (f.getAttribute('action') || location.pathname).split('?')[0].split('/').pop() || 'form'));
      } catch (e) {}
    }, true);

    // 2. posts sent by script (quotes, quiz, chat, pages with their own JS) to Bodno's backends
    var WATCH = [['functions/v1/site-forms', 'site-forms'], ['quiz-lead', 'quiz-lead'], ['finder.bodno.com', 'finder'], ['functions/v1/site-chat', 'chat'], ['emailer.bodno.com', 'quote']];
    function which(u) { u = String(u || ''); for (var i = 0; i < WATCH.length; i++) if (u.indexOf(WATCH[i][0]) > -1) return WATCH[i][1]; return null; }
    function emailIn(body) {
      try {
        if (!body) return null;
        var o = null;
        if (typeof body === 'string') { var t = body.trim(); if (t.charAt(0) === '{') o = JSON.parse(t); else { o = {}; new URLSearchParams(t).forEach(function (v, k) { o[k] = v; }); } }
        else if (typeof FormData !== 'undefined' && body instanceof FormData) { o = {}; body.forEach(function (v, k) { if (typeof v === 'string') o[k] = v; }); }
        else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) { o = {}; body.forEach(function (v, k) { o[k] = v; }); }
        if (!o) return null;
        if (typeof o.payload === 'string') { try { var p = JSON.parse(o.payload); if (p && p.fields) o = p.fields; } catch (e) {} }
        if (o.fields && typeof o.fields === 'object') o = o.fields;
        var e = o.email || o.email_address || o.customer_email || (o.contact && o.contact.email);
        return e ? String(e) : null;
      } catch (e) { return null; }
    }
    function op(u, body) { try { var m = String(u).match(/[?&]op=([a-z_]+)/i); if (m) return m[1]; if (typeof body === 'string' && body.charAt(0) === '{') { var j = JSON.parse(body); if (j && j.op) return String(j.op); if (j && j.form) return String(j.form); } if (typeof FormData !== 'undefined' && body instanceof FormData) { var pl = JSON.parse(String(body.get('payload') || '{}')); if (pl.form) return String(pl.form); } } catch (e) {} return ''; }
    function seen(u, body) { try { var w = which(u); if (!w) return; var em = emailIn(body); if (em) { var o = op(u, body); save(em, w + (o ? ':' + o : '')); } } catch (e) {} }
    if (window.fetch) {
      var f0 = window.fetch;
      window.fetch = function (input, init) {
        try { seen(typeof input === 'string' ? input : (input && input.url) || '', init && init.body); } catch (e) {}
        return f0.apply(this, arguments);
      };
    }
    try {
      var XP = window.XMLHttpRequest && XMLHttpRequest.prototype;
      if (XP && !XP.__bodnoSrc) {
        XP.__bodnoSrc = 1;
        var o0 = XP.open, s0 = XP.send;
        XP.open = function (m, u) { try { this.__bodnoSrcUrl = String(u || ''); } catch (e) {} return o0.apply(this, arguments); };
        XP.send = function (b) { try { seen(this.__bodnoSrcUrl, b); } catch (e) {} return s0.apply(this, arguments); };
      }
    } catch (e) {}
    window.bodnoSource = function () { return { first: get(localStorage, 'bodno_src_f'), session: get(sessionStorage, 'bodno_src_s'), visits: get(localStorage, 'bodno_src_v') }; };
  } catch (e) {}
})();
